export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>每日更新 · 高清大片免费看</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              麻花影院
              <span className="block text-2xl md:text-3xl lg:text-4xl font-sans font-light text-foreground-600 mt-2">
                最新电影热门电影大全
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              麻花影院聚合最新动作片、科幻片、喜剧电影等高清大片资源，
              覆盖十余个分类、5000+部影片，每日更新不断档。
            </p>
            <p className="text-base md:text-lg text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              无需注册，打开即看，高清流畅。无论你是动作迷、科幻控还是喜剧爱好者，
              都能在这里找到属于你的那部好片。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-primary-500">5000+</span>
                <span className="text-sm text-foreground-500">高清影片</span>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-accent-500">50+</span>
                <span className="text-sm text-foreground-500">每周更新</span>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-primary-500">10+</span>
                <span className="text-sm text-foreground-500">分类覆盖</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#cards');
                  if (el) {
                    const top = el.getBoundingClientRect().top + window.scrollY - 64;
                    window.scrollTo({ top, behavior: 'smooth' });
                  }
                }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#ranking');
                  if (el) {
                    const top = el.getBoundingClientRect().top + window.scrollY - 64;
                    window.scrollTo({ top, behavior: 'smooth' });
                  }
                }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-100 text-foreground-700 font-medium rounded-full hover:bg-background-200 transition-colors border border-background-300/60 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bar-chart-line"></i>
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="relative rounded-2xl overflow-hidden" style={{ aspectRatio: '4/5' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20collage%20with%20multiple%20film%20strips%20floating%20in%20warm%20theater%20lighting%20red%20velvet%20curtain%20dramatic%20golden%20spotlight%20classic%20cinema%20aesthetic%20rich%20textures%20professional%20movie%20poster%20composition%20artistic&width=900&height=1125&seq=mahua-hero-main&orientation=portrait"
                  alt="麻花影院 - 最新电影热门大片聚合平台主视觉"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-accent-400/30 rounded-full blur-2xl"></div>
              <div className="absolute -top-4 -left-4 w-20 h-20 bg-primary-400/20 rounded-full blur-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}